import {Row} from "antd";
import React from "react";
import {IoIosWarning} from "react-icons/io";
import {ModalContent, SaucesContainer} from "./index.style";

const CategoryAlert = ({visible, setVisible, heading, body}) => {

    return (
        <SaucesContainer centered open={visible} footer={false} onCancel={() => setVisible(false)}>
            <ModalContent style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "40px"}}>
                        <IoIosWarning style={{
                            color: "#FF9800",
                            fontSize: "64px",
                        }}/>
                        <div>
                            <h2 style={{margin: 0, marginLeft: 0}}>{heading}</h2>
                            <Row >
                                <h6>{body}</h6>
                            </Row>
                        </div>

                    </div>
                </div>

            </ModalContent>
        </SaucesContainer>
    );
};

export default CategoryAlert;

